import CheckupApi from "../api/checkup";

const env = process.env;
const checkupApi = new CheckupApi(
  env.VUE_APP_API_CHECKUP_URL,
  env.VUE_APP_API_CHECKUP_TIMEOUT
);

const state = {
  catalogs: [],
  items: [],
  prescriptions: {},
  answers: {},
};

const getters = {
  clientCheckupPrescriptions: state => clientId => {
    if (!state.prescriptions[clientId]) {
      return [];
    }

    return state.prescriptions[clientId];
  },

  clientCheckupAnswers: state => clientId => {
    if (!state.answers[clientId] || state.answers[clientId].length === 0) {
      return [];
    }

    return state.answers[clientId];
  },
};

const mutations = {
  SET_CHECKUP_CATALOGS: (state, payload) => {
    state.catalogs = payload;
  },

  SET_CHECKUP_ITEMS: (state, payload) => {
    state.items = payload;
  },

  SET_CHECKUP_PRESCRIPTIONS: (state, payload) => {
    state.prescriptions[payload.clientId] = payload.items;
    state.prescriptions = Object.assign({}, state.prescriptions);
  },

  SET_CHECKUP_ANSWERS: (state, payload) => {
    state.answers[payload.clientId] = payload.items;
    state.answers = Object.assign({}, state.answers);
  },
};

const actions = {
  LOAD_CHECKUP_CATALOGS: async (context) => {
    const token = context.rootState.token;
    const data = await checkupApi.getCatalogs(token);

    context.commit('SET_CHECKUP_CATALOGS', data.items);
  },

  LOAD_CHECKUP_ITEMS: async (context) => {
    const token = context.rootState.token;
    const data = await checkupApi.getItems(token);

    context.commit('SET_CHECKUP_ITEMS', data.items);
  },

  LOAD_CHECKUP_PRESCRIPTIONS: async (context, payload) => {
    const token = context.rootState.token;
    const result = await checkupApi.getPrescriptions(token, payload);
    const data = { items: result.items, clientId: payload };

    context.commit('SET_CHECKUP_PRESCRIPTIONS', data, payload);
  },

  ADD_CHECKUP_PRESCRIPTION: async (context, payload) => {
    const token = context.rootState.token;
    const { data, client } = payload;

    await checkupApi.addPrescription(token, data);

    await context.dispatch('LOAD_CHECKUP_PRESCRIPTIONS', client);
  },

  UPDATE_CHECKUP_PRESCRIPTION: async (context, payload) => {
    const token = context.rootState.token;
    const { id, data, client } = payload;

    await checkupApi.updatePrescription(token, id, data);

    await context.dispatch('LOAD_CHECKUP_PRESCRIPTIONS', client);
  },

  LOAD_CHECKUP_ANSWERS: async (context, payload) => {
    const token = context.rootState.token;
    const result = await checkupApi.getAnswers(token, payload);
    const data = { items: result.items, clientId: payload };

    context.commit('SET_CHECKUP_ANSWERS', data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};